import React from 'react';
import s from './DeactivatedUserPage.module.css'
import logo from '../../../assets/img/logo_without_text.svg'
import MyBtn from "../../../components/ui/MyBtn/MyBtn";
import {useNavigate} from "react-router-dom";

const DeactivatedUserPage = () => {

    const navigate = useNavigate();

    return (
        <div className={s.wrapper}>
            <div className={s.content}>
                <div className={s.flex}>
                    <img src={logo} alt="" className={s.img}/>
                    <p className={s.title}>Your account has been deactivated</p>
                    <p className={s.subtitle}>
                        <span>
                            Thank you for using LuxPay.
                        </span>
                        <br/>
                        <span>
                             Please contact
                            <span className={s.colorfull}>&nbsp;
                                <a href="mailto:support@luxpay.lt">
                                    support@luxpay.lt
                                </a>
                            </span>&nbsp;
                            if you have any questions.
                        </span>
                    </p>
                    <div className={s.button_wrapper}>
                        <MyBtn
                            isPersonalAccountBtn
                            large
                            title={'Return to LuxPay'}
                            onClick={() => navigate('/')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeactivatedUserPage;
